export enum CreatorFilter {
        Confirmed = 'Confirmed',
        Invited = 'Invited',
        Rejected = 'Canceled',
        NotAvailable = 'Not available',
        Pending = 'Pending',
        Suggested = 'Suggested',
        Negotiation = 'Negotiation',
    };
